export default {
    data() {
        return {
            isLoading: false,
        }
    },

    computed: {
        viewMode() {
            return !this.isEdit && this.value;
        },

        searchDateFormat() {
            return [
                this.formatDate(this.searchDate[0], 'YYYY-MM-DD'),
                this.formatDate(this.searchDate[1], 'YYYY-MM-DD'),
            ];
        },

        userGudang() {
            return window.user.user_gudang ? window.user.user_gudang.gudang : null;
        },

        isSuperAdmin() {
            return window.user.type == 'super-admin';
        },
    },

    methods: {
        formatUTC(value, fmt = 'YYYY-MM-DD HH:mm:ss'){
            return !value ? '-' : this.moment(value).tz('UTC').format(fmt);
        },

        now(fmt = 'DD MMMM YYYY') {
            return this.moment().tz(window.user.timezone).format(fmt);
        },

        formatDate(value, fmt = 'DD MMMM YYYY') {
            return !value ? '-' : this.moment(value).tz(window.user.timezone).format(fmt);
        },

        formatDatetime(value, fmt = 'DD MMMM YYYY HH:mm') {
            return !value ? '-' : this.moment(value).tz(window.user.timezone).format(fmt);
        },

        convertUserTimezone(value) {
            if (!value) {
                return '';
            }
            let locationOffset = new Date().getTimezoneOffset() / 60;
            let userOffset = this.moment().tz(window.user.timezone)._offset / 60;
            let date = new Date(value);
            date.setHours(date.getHours() + ((locationOffset + userOffset) * -1));
            return date;
        },

        _formatNumber(value, isStrict) {
            if (!value && !isStrict) {
                return '-';
            }
            return new Intl.NumberFormat('id-ID').format(value);
        },

        formatNumber(value) {
            return this._formatNumber(value, false);
        },

        formatNumberStrict(value) {
            return this._formatNumber(value, true);
        },

        formatValue(value) {
            return value || '-';
        },

        requestFailed(response) {
            this.isLoading = false;
            this.$Progress.fail();
            if (response.message == 'Request failed with status code 403') {
                this.$router.replace({ path: '/forbidden' });
                return;
            }
            if (!response.response.data.errors) {
                Toast.fire({
                    icon: 'error',
                    title: response.response.data.data,
                });
            }
            let errors = response.response.data.errors;
            Object.keys(errors).forEach(function (key) {
                Toast.fire({
                    icon: 'error',
                    title: errors[key]
                });
            });
        },

        isSameDay(datetime, days) {
            if (!days) {
                days = 0;
            }
            var date = this.moment(datetime).add(days, 'days').tz(window.user.timezone).format('YYYYMMDD');
            var today = this.moment().tz(window.user.timezone).format('YYYYMMDD');
            return date == today;
        },

        isBeforeDay(datetime, days) {
            if (!days) {
                days = 0;
            }
            var date = this.moment(datetime).add(days, 'days').tz(window.user.timezone).format('YYYYMMDD');
            var today = this.moment().tz(window.user.timezone).format('YYYYMMDD');
            return date >= today;
        },

        $can(ability) {
            if (window.user.current_team.ability.permissions.includes(ability)) {
                return true;
            }
            return false;
        },

        camelCase(str, splitter = ' ', join = '') {
            if (!str) {
                return '-';
            }
            let strArr = str.split(splitter);
            strArr.forEach((val, index) => {
                strArr[index] = val.charAt(0).toUpperCase() + val.slice(1);
            });
            return strArr.join(join);
        },
    }
}
